<template lang="html">
    <modal :on-close="close">
        <div class="row">
            <div class="modal-header">
                <h3>{{ $store.getters.companyContent.title }}</h3>
            </div>
        </div>

        <div class="row">
            <div class="modal-body">
                {{ $store.getters.companyContent.body }}
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from './Modal.vue';

export default {
    components: {
        Modal
    },
    methods: {
        close: function () {
            this.$store.dispatch('updateContentShow', false);
            this.title = '';
            this.body = '';
        },
        savePost: function () {
            this.close();
        }
    }
}
</script>

<style lang="scss">
@import "../../assets/resources/css/partials/variables";

.modal-header h3 {
    margin-top: 0;
    color: $theme-color;
}

.modal-body {
    margin: 20px 0;
}

</style>



// WEBPACK FOOTER //
// NewContent.vue?61b42c96